import {request} from '../services/request';
import {expenseConstants} from '../constants';
import {backendEndpoints} from '../../api';
import {apiHelpers} from '../../utils/helpers';

const errorHandlerProps = {disableAlert: true};

const {getUrl} = apiHelpers;

const getExpenses = ({query, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: backendEndpoints.GET_EXPENSES,
      query,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const getExpensesMonthlySpending = ({query, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: backendEndpoints.GET_EXPENSES_MONTHLY_SPENDING,
      query,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const getExpensesTabsStatus = ({query, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: backendEndpoints.GET_EXPENSES_TABS_STATUS,
      query,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const getExpensesMissingDocumentsCount = ({query, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: backendEndpoints.GET_EXPENSES_MISSING_DOCUMENTS_COUNT,
      query,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const getEmployeeMonthlySpendings = ({query, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: backendEndpoints.GET_EMPLOYEE_MONTHLY_SPENDING,
      query,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const getExpense = ({id, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: getUrl(backendEndpoints.GET_EXPENSE, {id}),
      successCallback: (data) => {
        dispatch({
          type: expenseConstants.GET_EXPENSE,
          data
        });
        successCallback?.(data);
      },
      errorCallback
    });
  }
}

const getExpenseAttachmentUrls = ({id, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: getUrl(backendEndpoints.GET_EXPENSE_ATTACHMENT_URLS, {id}),
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const getExpenseRelatedInvoices = ({id, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: getUrl(backendEndpoints.GET_EXPENSE_RELATED_INVOICES, {id}),
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const getExpenseLogs = ({id, query, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: getUrl(backendEndpoints.GET_EXPENSE_LOGS, {id}),
      query,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const createExpense = ({data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.post({
      dispatch,
      url: backendEndpoints.POST_EXPENSE_CREATE,
      data,
      successCallback,
      errorCallback
    });
  }
}

const updateExpense = ({id, data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.put({
      dispatch,
      url: getUrl(backendEndpoints.PUT_EXPENSE_UPDATE, {id}),
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const approveExpense = ({id, data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.put({
      dispatch,
      url: getUrl(backendEndpoints.PUT_EXPENSE_APPROVE, {id}),
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const reassignExpense = ({id, data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.put({
      dispatch,
      url: getUrl(backendEndpoints.PUT_EXPENSE_REASSIGN, {id}),
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const reopenExpense = ({id, data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.patch({
      dispatch,
      url: getUrl(backendEndpoints.PATCH_EXPENSE_EDIT_REVIEW, {id}),
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const reimburseExpense = ({data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.post({
      dispatch,
      url: backendEndpoints.POST_EXPENSE_REIMBURSE,
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const reclaimExpense = ({data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.post({
      dispatch,
      url: backendEndpoints.POST_EXPENSE_BULK_RECLAIM,
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const reimburseAllExpenses = ({data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.post({
      dispatch,
      url: backendEndpoints.POST_EXPENSE_REIMBURSE_ALL,
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const reclaimAllExpenses = ({data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.post({
      dispatch,
      url: backendEndpoints.POST_EXPENSE_RECLAIM_ALL,
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const rejectExpense = ({id, data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.put({
      dispatch,
      url: getUrl(backendEndpoints.PUT_EXPENSE_REJECT, {id}),
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const updateExpenseStatus = ({id, data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.put({
      dispatch,
      url: getUrl(backendEndpoints.PUT_EXPENSE_STATUS, {id}),
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const bulkApproveExpenses = ({data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.post({
      dispatch,
      url: backendEndpoints.POST_EXPENSE_BULK_APPROVE,
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const bulkRejectExpenses = ({data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.post({
      dispatch,
      url: backendEndpoints.POST_EXPENSE_BULK_REJECT,
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const bulkReopenExpenses = ({data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.post({
      dispatch,
      url: backendEndpoints.POST_EXPENSE_BULK_REOPEN,
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const bulkUpdateExpenses = ({data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.put({
      dispatch,
      url: backendEndpoints.PUT_EXPENSES_BULK_UPDATE,
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const submitExpenseForReview = ({id, data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.patch({
      dispatch,
      url: getUrl(backendEndpoints.PATCH_EXPENSE_SUBMIT_FOR_REVIEW, {id}),
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const discardExpenseAutoApproval = ({id, data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.put({
      dispatch,
      url: getUrl(backendEndpoints.PUT_EXPENSE_DISCARD_AUTO_APPROVAL, {id}),
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const getBatchExpenses = ({data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.post({
      dispatch,
      url: backendEndpoints.POST_EXPENSES_BATCH,
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const downloadZipInvoices = ({query, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: backendEndpoints.GET_EXPENSES_ZIP_INVOICES,
      query,
      successCallback,
      errorCallback,
      errorHandlerProps,
    });
  }
}

const exportExpenses = ({headers, query, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      headers,
      url: backendEndpoints.GET_EXPENSES_EXPORT,
      query,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const deleteExpense = ({id, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.delete({
      dispatch,
      url: apiHelpers.getUrl(backendEndpoints.DELETE_EXPENSE, {id}),
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const recalculateExpensePolicyStatus = ({id, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.put({
      dispatch,
      url: apiHelpers.getUrl(backendEndpoints.PUT_EXPENSE_POLICY_STATUS_RECALCULATE, {id}),
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const linkInvoices = ({id, data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.put({
      dispatch,
      url: apiHelpers.getUrl(backendEndpoints.PUT_EXPENSE_LINK_INVOICES, {id}),
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const unlinkInvoices = ({id, data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.put({
      dispatch,
      url: apiHelpers.getUrl(backendEndpoints.PUT_EXPENSE_UNLINK_INVOICES, {id}),
      data,
      successCallback,
      errorCallback,
    })
  }
}

const createExpenseFromDocument = ({data, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.post({
      dispatch,
      url: backendEndpoints.POST_EXPENSE_FROM_DOCUMENT,
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const openAddExpenseModal = () => {
  return (dispatch) => {
    dispatch({
      type: expenseConstants.OPEN_ADD_EXPENSE_MODAL,
    });
  }
}

const closeAddExpenseModal = () => {
  return (dispatch) => {
    dispatch({
      type: expenseConstants.CLOSE_ADD_EXPENSE_MODAL,
    });
  }
}

const openDuplicatesModal = ({duplicateGroupId, expenseId, date} = {}) => {
  return (dispatch) => {
    dispatch({
      type: expenseConstants.OPEN_DUPLICATES_MODAL,
      data: {duplicateGroupId, expenseId, date},
    });
  }
}

const closeDuplicatesModal = () => {
  return (dispatch) => {
    dispatch({
      type: expenseConstants.CLOSE_DUPLICATES_MODAL,
    });
  }
}

const getDuplicateExpenses = ({query, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: backendEndpoints.GET_EXPENSES,
      query,
      successCallback,
      errorCallback,
      errorHandlerProps,
    });
  }
}

const dismissDuplicate = ({id, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.post({
      dispatch,
      url: getUrl(backendEndpoints.POST_EXPENSE_DISMISS_DUPLICATE, {id}),
      successCallback,
      errorCallback,
      errorHandlerProps,
    });
  }
}

const reactivateDuplicate = ({id, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.post({
      dispatch,
      url: getUrl(backendEndpoints.POST_EXPENSE_REACTIVATE_DUPLICATE, {id}),
      successCallback,
      errorCallback,
      errorHandlerProps,
    });
  }
}

export const expenseActions = {
  getExpenses,
  getExpensesMonthlySpending,
  getExpensesTabsStatus,
  getExpensesMissingDocumentsCount,
  getEmployeeMonthlySpendings,
  getExpense,
  getExpenseAttachmentUrls,
  getExpenseRelatedInvoices,
  getExpenseLogs,
  getBatchExpenses,

  approveExpense,
  bulkApproveExpenses,
  bulkRejectExpenses,
  bulkReopenExpenses,
  bulkUpdateExpenses,
  reimburseExpense,
  reclaimExpense,
  reimburseAllExpenses,
  reclaimAllExpenses,
  createExpense,
  createExpenseFromDocument,
  deleteExpense,
  reassignExpense,
  rejectExpense,
  updateExpenseStatus,
  reopenExpense,
  submitExpenseForReview,
  discardExpenseAutoApproval,
  updateExpense,
  downloadZipInvoices,
  exportExpenses,
  recalculateExpensePolicyStatus,
  linkInvoices,
  unlinkInvoices,

  openAddExpenseModal,
  closeAddExpenseModal,
  openDuplicatesModal,
  closeDuplicatesModal,
  getDuplicateExpenses,
  dismissDuplicate,
  reactivateDuplicate,
};
